import React, { useState, useContext, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import { Button, DescriptionList, Loader } from '../../../../../ui';
import type { BadgeTone } from '../../../../../ui';
import TeacherStatusBadge from '../ui-pending/TeacherStatusBadge';
import { completedClass, cancelTheClass, deleteTeacherSlot, completedToNotConducted,classRecording,
   completedToNoShow, scheduleToCompleted ,Penalty, markAsJoin , studentPenalty, completeLesson, ongoingLesson, activeLevel, updateClassStatusToNoShow} from '../../../../../Api/apiUtils';
import { ConfigContext } from '../../../../../Api/global/ApiContext';
import { toast } from 'react-toastify';
import { EventEmitter } from 'stream';
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';
import BehaviouralForm from '../../../../../components/behaviouralForm';
import { Link } from 'react-router-dom';
import { Copy } from 'react-feather';
import { isTeacherLeaderDisabled } from '../../../../../utils/permissions';
import './Calendar.css';
import './modal.scss';

// Calendar booking statuses not in TEACHER_STATUS_TONES yet.
const CALENDAR_STATUS_TONES: Record<string, BadgeTone> = {
  not_scheduled: 'info',
  teacher_noshow: 'danger',
  paid_noshow: 'danger',
  deleted: 'neutral',
  'free slot': 'success',
  'special free slot': 'accent',
};

interface EventModalProps {
  isOpen: boolean;
  toggle: () => void;
  eventDetails: any;
  currentDateRange:any 
  fetchCalendarData: (fromDate: string, toDate: string) => void;
}

const EventModal: React.FC<EventModalProps> = ({ isOpen, toggle, eventDetails, fetchCalendarData,   currentDateRange }) => {
  console.log(eventDetails,"eventdeatils")
  const config = useContext(ConfigContext);
  const readOnly = isTeacherLeaderDisabled();
  const [isLoading, setIsLoading] = useState(false);
  const [showCancelConfirmationModal, setShowCancelConfirmationModal] = useState(false);
  const [showBehaviouralForm, setShowBehaviouralForm] = useState(false);
  const [levelId, setLevelId] = useState(null);
  const { fromDate, toDate } = currentDateRange;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showNoShowOptions, setShowNoShowOptions] = useState(false);
const [selectedNoShowStatus, setSelectedNoShowStatus] = useState('');
const [showForceCompleteModal, setShowForceCompleteModal] = useState(false);
const [recording, setRecording] = useState('');



  useEffect(() => {
    if (isOpen) {
      setShowCancelConfirmationModal(false);
      setShowBehaviouralForm(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const completeClassRecording = async () => {
      try {
        const teacherCredentialId = eventDetails?.teacherCredentialId;
        const classId = eventDetails?.classId;
        
        if (teacherCredentialId && classId) {
          const response = await classRecording(teacherCredentialId, classId); 
          setRecording(response);
          console.log("recording", recording);
        }
      } catch (err) {
        console.error('Error fetching class recording:', err);
      }
    };
  
    if (eventDetails?.teacherCredentialId && eventDetails?.classId) {
      completeClassRecording();
    }
  }, [eventDetails?.teacherCredentialId, eventDetails?.classId]);


  if (!eventDetails) return null;

  // const handleCancel = async () => {
  //   if (!selectedReason) {
  //     alert("Please select a reason for cancellation.");
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     const payload = {
  //       classId: eventDetails.classId,
  //       studentUserId: eventDetails.studentUserId,
  //       actionBy: "admin",
  //       reason: selectedReason,
  //     };



  //     trackEvent(MixpanelEvents.NOT_CONDUCTED_CLASS, {
  //       classId: eventDetails.classId,
  //       reason: selectedReason,
  //       teacherName:eventDetails.teacherName,
  //       teacherUserId:eventDetails.teacherUserId,
  //       studentName:eventDetails.studentName,
  //       studentUserId: eventDetails.studentUserId,
  //       startTime:eventDetails.startTime,
  //       page: "Teacher Calendar Modal",
  //     });
    
  //     await cancelClass(payload);
  //     console.log("Class cancelled successfully");
  //     fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
  //     toggle();
  //   } catch (error) {
  //     console.error("Error cancelling class:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleCancelClick = () => {
    setShowCancelConfirmationModal(true);
  };

  const handleConfirmCancel = async () => {
    setIsLoading(true);
    try {
      const payload = {
        classId: eventDetails.classId,
        studentUserId: eventDetails.studentUserId,
        reason: "On teacher request",
        actionType: "Admin-Teacher"
      };

      trackEvent(MixpanelEvents.CANCEL_CLASS, {
        page: "Teacher Calendar",
        studentUserId: eventDetails.studentUserId,
        classId: eventDetails.classId,
        reason: "On teacher request",
        teacherName: eventDetails.teacherName,
        teacherUserId: eventDetails.teacherUserId,
        actionBy: "teacher",
        startTime: eventDetails.startTime,
      });

      await cancelTheClass(payload);
      toast.success("Class cancelled successfully");
      setShowCancelConfirmationModal(false);
      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      toggle();
    } catch (error) {
      console.error("Error cancelling class:", error);
      toast.error("Error cancelling class");
    } finally {
      setIsLoading(false);
    }
  };



  const handleMarkAsJoin = async () => {
    setIsLoading(true);
    try {
  
     const classId = eventDetails.classId
     const action = "joined"
   

     trackEvent(MixpanelEvents.MARK_AS_JOIN, {
      classId: eventDetails.classId,
      teacherName:eventDetails.teacherName,
      teacherUserId:eventDetails.teacherUserId,
      studentName:eventDetails.studentName,
      studentUserId: eventDetails.studentUserId,
      startTime:eventDetails.startTime,
      page: "Teacher Calendar Modal",
    });

      await markAsJoin(classId, action);


      toast.success("Class marked as joined");
      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      toggle();
    } catch (error) {
      console.error("Error marking class as joined:", error);
      toast.error("Failed to mark class as joined");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePenalty = async () => {
    setIsLoading(true);
    try {
      if (!eventDetails.teacherId || !eventDetails.studentId || !eventDetails.classId || !eventDetails.slotId) {
        toast.error("Missing required data for penalty");
        return;
      }
  
      const payload = {
        teachetId: String(eventDetails.teacherId), 
        studentId: String(eventDetails.studentId),
        classId: String(eventDetails.classId),
        teacherslotId: String(eventDetails.slotId)
      };
  
      

      trackEvent(MixpanelEvents.MARK_AS_TEACHER_NOSHOW, {
        classId: eventDetails.classId,
        teacherslotId: eventDetails.slotId,
        teacherName:eventDetails.teacherName,
        teacherUserId:eventDetails.teacherUserId,
        studentName:eventDetails.studentName,
        studentUserId: eventDetails.studentUserId,
        startTime:eventDetails.startTime,
        page: "Teacher Calendar Modal",
      });
  
      // Call the API
      const response = await updateClassStatusToNoShow(eventDetails.classId, 'class_tnoshow');
      
      toast.success("Class status updated to teacher no-show successfully");
      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      toggle();
    } catch (error: any) {
      console.error("Error updating class status to no-show:", error);
      toast.error(error.response?.data?.message || error.message || "Failed to update class status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStudentPenalty = async () => {
    setIsLoading(true);
    try {
      // Validate required fields
      if (!eventDetails.teacherId || !eventDetails.studentId || !eventDetails.classId || !eventDetails.slotId) {
        toast.error("Missing required data for penalty");
        return;
      }
  
      const payload = {
        teachetId: String(eventDetails.teacherId), 
        studentId: String(eventDetails.studentId),
        classId: String(eventDetails.classId),
        teacherslotId: String(eventDetails.slotId)
      };
  

      trackEvent(MixpanelEvents.MARK_AS_STUDENT_NOSHOW, {
        classId: eventDetails.classId,
        teacherslotId: eventDetails.slotId,
        teacherName:eventDetails.teacherName,
        teacherUserId:eventDetails.teacherUserId,
        studentName:eventDetails.studentName,
        studentUserId: eventDetails.studentUserId,
        startTime:eventDetails.startTime,
        page: "Teacher Calendar Modal",
      });
      console.log("Sending penalty payload:", payload);
  
      // Call the API
      const response = await updateClassStatusToNoShow(eventDetails.classId, 'class_snoshow');
      
      toast.success("Class status updated to student no-show successfully");
      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      toggle();
    } catch (error: any) {
      console.error("Error updating class status to teacher no-show:", error);
      toast.error(error.response?.data?.message || error.message || "Failed to update class status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
  
    setIsLoading(true);
    try {
      if (!eventDetails.slotId) {
        console.error("Missing classId for deletion");
        return;
      }
   
      trackEvent(MixpanelEvents.FREE_SLOT_DELETION_ATTEMPTED, {
        slotId: eventDetails.slotId,
        teacherName:eventDetails.teacherName,
        teacherUserId:eventDetails.teacherUserId,
        studentName:eventDetails.studentName,
        studentUserId: eventDetails.studentUserId,
        startTime:eventDetails.startTime,
        page: "Teacher Calendar Modal",
      });
    
      console.log("datamixpnel",   window.mixpanel.track("Free Slot Deletion Attempted", {
        slotId: eventDetails.slotId,
        userId: localStorage.getItem("userId"), 
        page: " Teacher Calendar Modal",
      }) )
  
      await deleteTeacherSlot(eventDetails.slotId);
      toast.success("Slot deleted successfully");
    

      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);

      toggle();
    } catch (error) {
      console.error("Error deleting slot:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNoConducted = async () => {
    try {
      const response = await completedToNotConducted(eventDetails.classId);

    toast.success("Successfully marked as not conducted")
    fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
    toggle();
    trackEvent(MixpanelEvents.MARK_AS_COMPLETE_NOT_CONDUCTED, {
      slotId: eventDetails.slotId,
      teacherName:eventDetails.teacherName,
      teacherUserId:eventDetails.teacherUserId,
      studentName:eventDetails.studentName,
      studentUserId: eventDetails.studentUserId,
      startTime:eventDetails.startTime,
      page: "Teacher Calendar Modal",
    });
    } catch (error) {
 toast.error("Error while marking not conducted")
      console.error(error);
    }
  };
  
  const handleNoShow = async (status: string) => {
    setIsLoading(true);

    try {
      // Pass status along with classId to your API util function, if needed modify API method
      const response = await completedToNoShow(eventDetails.classId, status );
      toast.success(`Marked as no show: ${status}`);
      
      fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      toggle();
      trackEvent(MixpanelEvents.MARK_AS_NOSHOW, {
        slotId: eventDetails.slotId,
        status:status,
        teacherName:eventDetails.teacherName,
        teacherUserId:eventDetails.teacherUserId,
        studentName:eventDetails.studentName,
        studentUserId: eventDetails.studentUserId,
        startTime:eventDetails.startTime,
        page: "Teacher Calendar Modal",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to mark as no show");
    } finally {
      setIsLoading(false);
      setShowNoShowOptions(false);
      setSelectedNoShowStatus('');
    }
  };;
  

  const handleForceCompleted = async () => {
    try {
      const response = await scheduleToCompleted(eventDetails.classId);

    toast.success("Successfully marked as no show")

    trackEvent(MixpanelEvents.FORCE_COMPELETE_CLASS, {
      slotId: eventDetails.slotId,
      teacherName:eventDetails.teacherName,
      teacherUserId:eventDetails.teacherUserId,
      studentName:eventDetails.studentName,
      studentUserId: eventDetails.studentUserId,
      startTime:eventDetails.startTime,
      page: "Teacher Calendar Modal",
    });
    setShowForceCompleteModal(false)
    fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
    toggle();
    
    } catch (error) {
 toast.error("Error while marking noshow")
      console.error(error);
    }
  };


const handleCompleted = async () => {
  setIsLoading(true);
  try {
    const studentUserId = eventDetails.studentUserId;
    const courseId = eventDetails.courseId;
    const classId = eventDetails.classId;

    const activeLevelResponse = await activeLevel(studentUserId, courseId);
    const activeLevelData = activeLevelResponse.status?.[0];

    if (!activeLevelData) {
      // If null/empty, open Force Complete Modal
      setShowForceCompleteModal(true);
      return;
    }

    setLevelId(activeLevelData.level_id);
    setShowBehaviouralForm(true);
  } catch (e) {
    console.error(e);
  } finally {
    setIsLoading(false);
  }
};

  

  const handleBehaviouralFormComplete = async () => {
    setIsLoading(true);
    setIsSubmitting(true);
    const studentUserId = eventDetails.studentUserId;
    const courseId = eventDetails.courseId;
    const classId = eventDetails.classId;
  
    try {
      // 1. First get active level
      const activeLevelResponse = await activeLevel(studentUserId, courseId);
      console.log('Active Level Response:', activeLevelResponse);
      
      const activeLevelData = activeLevelResponse.status?.[0];
      if (!activeLevelData) {
        throw new Error('No active level data found');
      }
    
      const levelId = activeLevelData.level_id;
      setLevelId(activeLevelData.level_id);
      const classLevel = activeLevelData.level_name;
      console.log('Level Data:', { levelId, classLevel });
  
      let lessonNumberForPayload = 1; 
  
      try {
        console.log('Calling completeLesson...');
        const completedLessonsResponse = await completeLesson(studentUserId, classId);
        console.log('Complete Lesson Response:', completedLessonsResponse.lessonCompletionData);
        
        if (completedLessonsResponse.lessonCompletionData && completedLessonsResponse.lessonCompletionData.length > 0) {
          lessonNumberForPayload = completedLessonsResponse.lessonCompletionData[0].lesson_numbe;
          console.log('Using completed lesson number:', lessonNumberForPayload);
        } else {
          console.log('No completed lessons, calling ongoingLesson...');
          const ongoingLessonsResponse = await ongoingLesson(studentUserId, levelId);
          console.log('Ongoing Lesson Response:', ongoingLessonsResponse);
          
          if (ongoingLessonsResponse.lesson && ongoingLessonsResponse.lesson.lesson_number) {
            lessonNumberForPayload = ongoingLessonsResponse.lesson.lesson_number;
            console.log('Using ongoing lesson number:', lessonNumberForPayload);
          }
        }
      } catch (error) {
        console.error("Error fetching lesson data:", error);
      }
  
      const payload = {
        classId: classId,
        studentUserId: studentUserId,
        classNumber: eventDetails.classNumber,
        actionBy: "Teacher",
        classLevel: classLevel,
        lessonNumber: lessonNumberForPayload
      };

      trackEvent(MixpanelEvents.MARK_AS_COMPLETED, {
        slotId: eventDetails.slotId,
        classNumber: eventDetails.classNumber,
        lessonNumber: lessonNumberForPayload,
        classLevel: classLevel,
        teacherName: eventDetails.teacherName,
        teacherUserId: eventDetails.teacherUserId,
        studentName: eventDetails.studentName,
        studentUserId: eventDetails.studentUserId,
        startTime: eventDetails.startTime,
        page: "Teacher Calendar Modal",
      });
    
      console.log('Final Payload:', payload);
  
      await completedClass(payload);
      console.log('Class successfully marked as completed');
      
      // Fetch new data before closing modal
      await fetchCalendarData(currentDateRange.fromDate, currentDateRange.toDate);
      
      // Close modal and reset states after everything is done
      setShowBehaviouralForm(false);
      toggle();
      
    } catch (error) {
      console.error("Error in handleCompleted:", error);
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  const isPastSlotTime = () => {
    if (eventDetails) {
       // Combine date and time strings
      const slotDateTimeString = `${eventDetails.slotDate}T${eventDetails.startTime}+05:30`; // IST offset
      const slotDateTime = new Date(slotDateTimeString);
      const now = new Date();

      return now > slotDateTime;
    }
    return false
  };
  const statusText = eventDetails.classBookingStatus
    || (eventDetails.specialSlot ? "Special Free slot"      : "Free slot");

  const openQa = (path: string) => {
    const classId = eventDetails?.classId || '';
    if (classId && eventDetails) {
      localStorage.setItem(`qaEventDetails_${classId}`, JSON.stringify(eventDetails));
    }
    window.open(
      `${window.location.origin}${process.env.PUBLIC_URL || ''}${path}?classId=${classId}`,
      '_blank'
    );
  };

  const detailItems = [
    {
      label: "Status",
      value: <TeacherStatusBadge status={statusText} label={statusText} tones={CALENDAR_STATUS_TONES} />,
    },
    ...(eventDetails && (eventDetails.isBooked === true || eventDetails.classBookingStatus === "COMPLETED")
      ? [{
          label: "Student Name",
          value: (
            <Link
              to={`/pages/student-profile/${eventDetails.studentCredentialId}/${eventDetails.studentId}`}
              className="tp-cal-modal__link"
            >
              {eventDetails.studentName}
            </Link>
          ),
        }]
      : []),
    { label: "Teacher Name", value: eventDetails.teacherName },
    ...(eventDetails && eventDetails.isBooked === true
      ? [{ label: "Class Number", value: eventDetails.classNumber }]
      : []),
    { label: "Slot Date in IST", value: eventDetails.slotDate },
    { label: "Start Time in IST", value: eventDetails.startTime },
    { label: "End Time in IST", value: eventDetails.endTime },
    ...(eventDetails && (eventDetails.classBookingStatus === "COMPLETED")
      ? [{
          label: "Recording",
          value: Array.isArray(recording) && recording.length > 0 ? (
            <span className="tp-cal-modal__copies">
              {(recording || []).map((rec: any, index: number) => (
                <Button
                  key={index}
                  variant="secondary"
                  size="sm"
                  icon={<Copy size={13} aria-hidden />}
                  onClick={() => {
                    navigator.clipboard.writeText(rec);
                    toast.success("Recording link copied!");
                  }}
                >
                  {recording.length > 1 ? `Copy ${index + 1}` : "Copy"}
                </Button>
              ))}
            </span>
          ) : (
            "No recording found"
          ),
        }]
      : []),
  ];

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="tp-cal-modal"
      contentClassName="tp-cal-modal__content"
    >
      <ModalHeader toggle={toggle}>{showBehaviouralForm ? "Behavioural Form" : "Event Details"}</ModalHeader>
      <ModalBody className="tp-cal-modal__body">
        {isSubmitting ? (
          <Loader label="Submitting form..." />
        ) : !showBehaviouralForm ? (
          <>
            <DescriptionList items={detailItems} />
            {eventDetails && (eventDetails.classBookingStatus === "COMPLETED") && (
              <div className="tp-cal-modal__qa">
                <Button variant="accent" block onClick={() => openQa('/pages/qa-analysis')}>
                  Academic QA
                </Button>
                <Button variant="accent" block onClick={() => openQa('/pages/ld-qa-analysis')}>
                  L&D QA
                </Button>
              </div>
            )}
          </>
        ) : (
          showBehaviouralForm && levelId && (
            <BehaviouralForm
              onComplete={handleBehaviouralFormComplete}
              onBack={() => setShowBehaviouralForm(false)}
              courseId={eventDetails.courseId}
              eventDetails={eventDetails}
              levelId={levelId}
            />
          )
        )}
        
      </ModalBody>
      <ModalFooter className="tp-cal-modal__footer">
        <div className="tp-cal-modal__actions">
          {eventDetails.classBookingStatus === "COMPLETED" && (
            <Button
              onClick={handleNoConducted}
              hidden={showNoShowOptions}
              variant="secondary"
              block
              disabled={readOnly}
              title={readOnly ? "Disabled for Teacher Leaders" : undefined}
            >
              Not Conducted
            </Button>
          )}

          {eventDetails.classBookingStatus === "COMPLETED" && (
            <Button
              variant="secondary"
              block
              onClick={() => setShowNoShowOptions(true)}
              hidden={showNoShowOptions}
              disabled={isLoading || readOnly}
              title={readOnly ? "Disabled for Teacher Leaders" : undefined}
            >
              No Show
            </Button>
          )}

          {showNoShowOptions && (
            <fieldset className="tp-cal-modal__noshow">
              <legend className="ds-field__label">Select the below status</legend>
              {[
                { value: "class_snoshow", label: "Student No Show" },
                { value: "class_tnoshow", label: "Teacher No Show" },
                { value: "class_stnoshow", label: "Both No Show" },
              ].map(({ value, label }) => (
                <FormGroup check key={value}>
                  <Label check>
                    <Input
                      type="radio"
                      className="levelChk"
                      name="noShowStatus"
                      value={value}
                      checked={selectedNoShowStatus === value}
                      onChange={() => setSelectedNoShowStatus(value)}
                    />
                    {label}
                  </Label>
                </FormGroup>
              ))}
              <div className="tp-cal-modal__noshow-actions">
                <Button variant="secondary" block onClick={() => setShowNoShowOptions(false)}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  block
                  onClick={() => {
                    if (!selectedNoShowStatus) {
                      alert("Please select a no show status.");
                      return;
                    }
                    handleNoShow(selectedNoShowStatus);
                  }}
                  disabled={isLoading || !selectedNoShowStatus}
                >
                  Confirm No Show
                </Button>
              </div>
            </fieldset>
          )}

          {!showBehaviouralForm &&
            !isSubmitting &&
            eventDetails &&
            (eventDetails.classBookingStatus === "SCHEDULED" ||
              eventDetails.classBookingStatus === "RESCHEDULED") &&
            !showCancelConfirmationModal && (
              <Button
                variant="danger"
                block
                onClick={handleCancelClick}
                disabled={isLoading || readOnly}
                title={readOnly ? "Disabled for Teacher Leaders" : undefined}
              >
                Cancel Class
              </Button>
            )}

          {!showBehaviouralForm &&
            !isSubmitting &&
            eventDetails &&
            eventDetails.isBooked === true &&
            eventDetails.classBookingStatus !== "COMPLETED" &&
            !showCancelConfirmationModal && (
              <>
                <Button
                  variant="primary"
                  block
                  onClick={handleCompleted}
                  disabled={isLoading || readOnly}
                  title={readOnly ? "Disabled for Teacher Leaders" : undefined}
                >
                  {isLoading ? "Completing..." : "Complete Class"}
                </Button>
                <Button
                  variant="secondary"
                  block
                  onClick={handleMarkAsJoin}
                  disabled={isLoading || readOnly}
                  title={readOnly ? "Disabled for Teacher Leaders" : undefined}
                >
                  {isLoading ? "Processing..." : "Mark As Join"}
                </Button>
                <Button
                  variant="secondary"
                  block
                  onClick={handlePenalty}
                  disabled={isLoading || readOnly}
                  title={readOnly ? "Disabled for Teacher Leaders" : undefined}
                >
                  {isLoading ? "Processing..." : "Mark As Teacher Noshow"}
                </Button>
                <Button
                  variant="secondary"
                  block
                  onClick={handleStudentPenalty}
                  disabled={isLoading || readOnly}
                  title={readOnly ? "Disabled for Teacher Leaders" : undefined}
                >
                  {isLoading ? "Completing..." : "Mark As Student Noshow"}
                </Button>
              </>
            )}

          {(eventDetails && eventDetails.isBooked === false) || eventDetails.isSpecialSlot === true ? (
            <Button
              variant="danger"
              block
              onClick={handleDelete}
              disabled={isLoading || readOnly}
              title={readOnly ? "Disabled for Teacher Leaders" : undefined}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          ) : null}
        </div>
      </ModalFooter>

      <Modal isOpen={showForceCompleteModal} toggle={() => setShowForceCompleteModal(false)} centered>
        <ModalHeader toggle={() => setShowForceCompleteModal(false)}>Force Complete</ModalHeader>
        <ModalBody>Are you sure you want to forcefully mark this class as completed?</ModalBody>
        <ModalFooter className="tp-cal-modal-confirm__footer">
          <Button variant="primary" onClick={handleForceCompleted}>
            Mark as Complete
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showCancelConfirmationModal} toggle={() => setShowCancelConfirmationModal(false)} centered>
        <ModalHeader toggle={() => setShowCancelConfirmationModal(false)}>Confirm Cancellation</ModalHeader>
        <ModalBody>Are you sure you want to cancel this class?</ModalBody>
        <ModalFooter className="tp-cal-modal-confirm__footer">
          <Button
            variant="secondary"
            onClick={() => setShowCancelConfirmationModal(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmCancel}
            disabled={isLoading || readOnly}
          >
            {isLoading ? "Cancelling..." : "Confirm Cancel"}
          </Button>
        </ModalFooter>
      </Modal>
    </Modal>
  );
};

export default EventModal;